import {
  contact,
  Contact,
  ContactData,
  ContactWithMessage,
  createNewContact,
} from 'mostra';

const {
  SnapShot,
} = contact;

export {
  SnapShot,
  Contact,
  ContactData,
  ContactWithMessage,
  createNewContact,
};
export default contact;
